export const TOOLS_TESTING = `
# Testing Tools

- Run the narrowest meaningful test first, then broaden when shared behavior or release artifacts are affected.
- Prefer deterministic fixtures, isolated temporary directories, and explicit assertions over timing assumptions.
- Record the exact command and observed result in the mission evidence.
`;
